import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const ImageSlider = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const preloadImages = () => {
      const images = [
        "/banners/Banner-1.webp",
        "/banners/Banner-2.webp",
        "/banners/Banner-3.webp",
        "/banners/Banner-4.webp",
        "/banners/Banner-5.webp",
        "/banners/Banner-6.webp",
        "/banners/Banner-7.webp", 
      ];
      images.forEach((src) => {
        const link = document.createElement("link");
        link.rel = "preload";
        link.as = "image";
        link.href = src;
        document.head.appendChild(link);
      });
    };
    preloadImages();
  }, []);

  // Setas reais em vez daquela div vermelha e verde
  function NextArrow(props) {
    const { onClick } = props;
    return (
      <div
        className="absolute top-1/2 right-4 md:right-8 -translate-y-1/2 z-10 cursor-pointer bg-black/30 hover:bg-black/60 p-2 md:p-3 rounded-full transition-all"
        onClick={onClick}
      >
        <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7"></path>
        </svg>
      </div>
    );
  }
  
  function PrevArrow(props) {
    const { onClick } = props;
    return (
      <div
        className="absolute top-1/2 left-4 md:left-8 -translate-y-1/2 z-10 cursor-pointer bg-black/30 hover:bg-black/60 p-2 md:p-3 rounded-full transition-all"
        onClick={onClick}
      >
        <svg className="w-6 h-6 md:w-8 md:h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 19l-7-7 7-7"></path>
        </svg>
      </div>
    );
  }

  const images = [
    { src: t('slider.banner1'), link: "https://save.com.br/categoria/plafon" },         
    { src: t('slider.banner2'), link: "https://save.com.br/blog/" },                       
    { src: t('slider.banner3'), link: "https://save.com.br/categoria/fitas-led"},  
    { src: t('slider.banner4'), link: "https://save.com.br/canal-do-arquiteto" },          
    { src: t('slider.banner5'), link: "https://save.com.br/canal-do-arquiteto" },          
    { src: t('slider.banner6'), link: "https://save.com.br/colecao-luce-lineare" },        
    { src: t('slider.banner7'), link: "/showroom" },                                       
  ];

  const settings = {
    dots: false,
    infinite: true,
    fade: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
    swipeToSlide: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />
  };

  return (
    <div className="relative w-full mx-0 overflow-hidden" aria-hidden="false">
      <Slider {...settings}>
        {images.map((image, index) => (
          <div key={index} className="outline-none focus:outline-none">
            <a href={image.link} className="block w-full h-full">
              <img
                src={image.src}
                srcSet={`${image.src} 320w, ${image.src} 480w, ${image.src} 800w`}
                sizes="(max-width: 320px) 280px, (max-width: 480px) 440px, 800px"
                alt={`Slide ${index + 1}`}
                aria-label="Slide"
                loading="lazy"
                className="w-full object-cover"
              />
            </a>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ImageSlider;